import React, { useState, useEffect, useCallback } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import DataTable from "react-data-table-component";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import Popup from "../common/popup";
import moment from "moment";
import discountIcon from "../assets/images/discount-icon.png";
import { useTranslation } from "react-i18next";

const Stripepaymentlog = () => {
  const { t } = useTranslation();
  const [searchTextVal, setSearchTextVal] = useState("");
  const [stripeloglist, setStripeloglist] = useState([]);
  const [templist, setTemplist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [popupView, setPopupView] = useState("");
  const [popupView1, setPopupView1] = useState("");
  const [alertPopup, setAlertPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [oaccountName, setOaccountName] = useState("");
  const [oaccountEmail, setOaccountEmail] = useState("");
  const [oaccountAddress, setOaccountAddress] = useState("");

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) !== "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_stripelog")
  ) {
    window.location.href = "/unauthorized";
  }

  const priceFormat = (price) => {
    return price.toLocaleString("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  };

  const str_replace = (product_name) => {
    if (product_name !== "") {
      product_name = product_name.replaceAll("amp;", "&");
      product_name = product_name.replaceAll("apos;'", "'' ");
      product_name = product_name.replaceAll("quot;'", "'' ");
      return product_name;
    } else {
      return product_name;
    }
  };

  const getOrderNotes = (OrderNote) => {
    let note_test = OrderNote.replaceAll(" PIXHALLCSL", "");
    note_test = note_test.replaceAll("amp;", "&");
    note_test = note_test.replaceAll("apos;", "'' ");
    note_test = note_test.replaceAll("apos;'", "'' ");
    note_test = note_test.replaceAll("quot;'", "'' ");
    note_test = note_test.replaceAll("quot;", "'' ");
    note_test = note_test.replaceAll("'' '", "'' ");
    return note_test;
  };

  const vatAmountCalcuation = (order) => {
    let totalAmount = 0;
    order.items.map((item) => {
      if (item.TaxCode !== "" && item.TaxCode === "T1") {
        totalAmount += item.LinePrice;
      }
    });
    return totalAmount;
  };

  const getStripelogslist = useCallback(() => {
    let URL = BaseUrl + "admin/stripelogs";
    http
      .get(URL)
      .then((response) => {
        const sortedData = response.data.data
          .filter((item) => item.orderID)
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setStripeloglist(sortedData);
        setLoading(false);
        setTemplist(response.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getStripelogslist();
  }, [getStripelogslist]);

  const createPopup = useCallback(
    (
      order,
      subTotal,
      ordertotal,
      vatAmount,
      vatTotalAmount,
      accountName,
      accountEmail,
      accountAddress,
    ) => {
      const sortedItems = [...order.items].sort((a, b) => {
        if (a.UnitPrice === 0 && b.UnitPrice !== 0) return 1;
        if (a.UnitPrice !== 0 && b.UnitPrice === 0) return -1;
        return 0;
      });
      let popupResult = (
        <Popup
          extClass="order-pop my-order-details-pop"
          headMoreTxt={
            <>
              <div className="order-top">
                <div className="bottom order-flex">
                  <div className="order_no_details">
                    <h3>
                      {t("order_no_txt")} - {order.OrderNumber}
                    </h3>
                    <p>
                      {t("order_placed_on_txt")}:{" "}
                      <span className="date">
                        {moment(order.createdAt).format("DD/MM/YYYY hh:mm A")}
                      </span>
                    </p>
                    <p>
                      {t("order_deleivery_on_txt")}:{" "}
                      <span className="date"> {order.DateRequired} </span>
                    </p>
                    {order.PaymentMethod === "A" && (
                      <p>
                        {t("payment_method_txt")}:{" "}
                        <span className="pay">
                          {order.OrderPaid === "YES"
                            ? t("paid_pay_later_txt")
                            : t("pay_later_txt")}
                        </span>
                      </p>
                    )}
                    {order.PaymentMethod === "K" && (
                      <p>
                        {t("payment_method_txt")}:{" "}
                        <span className="pay">{t("online_payment_txt")}</span>
                      </p>
                    )}
                    <p>
                      {t("status_txt")}:
                      <span className="pay"> {order.OrderStatus}</span>
                    </p>
                  </div>
                  <div className="order_account_details">
                    <p>
                      {t("name_txt")}:{" "}
                      <span className="date">{accountName}</span>
                    </p>
                    <p>
                      {t("account_code_txt")}:{" "}
                      <span className="date">{order.accountCode}</span>
                    </p>
                    <p>
                      {t("email_address_txt")}:{" "}
                      <span className="pay">{accountEmail}</span>
                    </p>
                    <p>
                      {t("address_txt")}:{" "}
                      <span className="pay">{accountAddress}</span>
                    </p>
                    {order.PODetails && (
                      <p>
                        {t("po_details_txt")}:{" "}
                        <span className="pay">{order.PODetails}</span>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </>
          }
          closebtn={
            <>
              <div className="pop-header-top order-top">
                <div className="head">
                  <h4>{t("order_details_txt")} - {order.OrderNumber}</h4>
                </div>
                <span
                  onClick={() => setPopupView1("")}
                  className="close"
                ></span>
              </div>
            </>
          }
          bodyMoreTxt={
            <>
              <div className="modal-table">
                <h4 className="item-title">{t("ordered_items_txt")}</h4>
                <div className="checkout-table">
                  <div className="table_overflow">
                    <table>
                      <thead>
                        <tr>
                          <td>{t("product_txt")}</td>
                          <td>{t("unit_of_sale_txt")}</td>
                          <td>{t("quantity_txt")}</td>
                          <td align="center">{t("price_txt")}</td>
                          <td align="right">{t("total_txt")}</td>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedItems.map((item, index) => {
                          return (
                            item.QuantityOrdered > 0 && (
                              <tr
                                key={index}
                                className={
                                  item.UnitPrice === 0 ? "free-prod-bg" : ""
                                }
                              >
                                <td
                                  data-title={t("product_txt")}
                                  className="data-product-hide"
                                >
                                  {str_replace(item.Description)} (
                                  {item.ProductNumber.includes("_")
                                    ? item.ProductNumber.substring(
                                        0,
                                        item.ProductNumber.indexOf("_"),
                                      )
                                    : item.ProductNumber}
                                  )
                                  {item.TaxCode !== "" &&
                                    item.TaxCode === "T1" && (
                                      <span className="color-red">*</span>
                                    )}
                                  {item.OfferFlag === "true" && (
                                    <span className="offer-tag-wrap">
                                      <span className="offer-tag">
                                        <img
                                          src={discountIcon}
                                          alt="Offer"
                                          className="tag-icon"
                                        />
                                        {t("special_offer_txt")}
                                      </span>
                                    </span>
                                  )}
                                </td>
                                <td data-title="Unit of Sale">
                                  {item.PricingUnit}
                                </td>
                                <td data-title="Quantity">
                                  {item.QuantityOrdered}
                                </td>
                                <td data-title="Price" align="center">
                                  {priceFormat(item.UnitPrice)}
                                </td>
                                <td data-title="Total" align="right">
                                  {priceFormat(item.LinePrice)}
                                </td>
                              </tr>
                            )
                          );
                        })}
                      </tbody>
                      <thead className="ord-grand-total">
                        {order.OrderNote !== "" && order.OrderNote !== null && (
                          <tr>
                            <td align="left" width={120} colSpan="7">
                              {t("order_notes_txt")}:{" "}
                              <span className="order_remarks">
                                {getOrderNotes(order.OrderNote)}
                              </span>
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td align="right" width={120} colSpan="4">
                            {t("subtotal_txt")}:
                          </td>
                          <td align="right">{priceFormat(subTotal)}</td>
                        </tr>
                        {vatAmount > 0 && (
                          <tr>
                            <td
                              align="right"
                              width={120}
                              colSpan="4"
                              className="td-vat-fee"
                            >
                              <span className="strong">
                                {t("vat_txt")}{" "}
                                <span className="vat-txt">
                                  ({t("20%_of_txt")}{" "}
                                  <span className="vat-amt">
                                    {priceFormat(vatTotalAmount)}
                                  </span>
                                  )<span className="color-red">*</span>:
                                </span>
                              </span>
                            </td>
                            <td className="cart-prod-vat" align="right">
                              {priceFormat(vatAmount)}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td align="right" width={120} colSpan="4">
                            {t("shipping_txt")}:
                          </td>
                          <td align="right">
                            <span className="color-red">{t("free_txt")}</span>
                          </td>
                        </tr>
                        <tr>
                          <td align="right" width={120} colSpan="4">
                            {t("grand_total_txt")}:
                          </td>
                          <td align="right">{priceFormat(ordertotal)}</td>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </div>
            </>
          }
        />
      );
      setPopupView1(popupResult);
    },
    [str_replace, priceFormat, getOrderNotes],
  );

  const viewOrderlogDetails = useCallback(
    (order, accountName, accountEmail, accountAddress) => {
      let ordertotal = 0;
      let subTotal = 0;
      order.items.map((item) => {
        ordertotal += item.LinePrice;
      });
      order.items.map((item) => {
        subTotal += item.UnitPrice * item.QuantityOrdered;
      });
      const vatTotalAmount = vatAmountCalcuation(order);
      let vatAmount = 0;
      if (vatTotalAmount > 0) {
        vatAmount = (vatTotalAmount / 100) * 20;
        ordertotal = ordertotal + vatAmount;
      }
      if (order.accountEmail !== undefined) {
        createPopup(
          order,
          subTotal,
          ordertotal,
          vatAmount,
          vatTotalAmount,
          order.accountName,
          order.accountEmail,
          order.accountAddress,
        );
      } else {
        let URL = BaseUrl + "admin/account/" + order.accountCode;
        http
          .get(URL)
          .then((response) => {
            const responseData = response.data.data;
            const addressFields = [
              responseData.accountAddress1,
              responseData.accountAddress2,
              responseData.accountAddress3,
              responseData.accountAddress4,
              responseData.accountAddress5,
            ];
            const resolvedAddress = addressFields
              .filter((field) => field !== undefined && field !== "")
              .join(", ");
            createPopup(
              order,
              subTotal,
              ordertotal,
              vatAmount,
              vatTotalAmount,
              responseData.accountName,
              responseData.accountEmail,
              resolvedAddress,
            );
          })
          .catch((err) => {
            setLoading(false);
          });
      }
    },
    [createPopup, vatAmountCalcuation],
  );

  const getOrderDetails = useCallback(
    (stripelog) => {
      setPopupView1(
        <Popup
          extClass="order-pop"
          headMoreTxt={<></>}
          closebtn={
            <>
              <div className="order-top">
                <div className="head">
                  <h4>
                    {t("order_details_txt")} - {stripelog.orderID}
                  </h4>
                </div>
                <span
                  onClick={() => setPopupView1("")}
                  className="close"
                ></span>
              </div>
            </>
          }
          bodyMoreTxt={<div className="loading-buffer"></div>}
        />,
      );
      setAlertPopup(false);
      setIsLoading(true);
      let numberOfAjaxCAllPending = 0;
      const timeInterval = 20000;
      const URL = BaseUrl + "admin/getorderdetails/" + stripelog.orderID;
      http
        .get(URL)
        .then((response) => {
          numberOfAjaxCAllPending++;
          const responseData = response.data.data[0];
          clearInterval(myInterval);
          setIsLoading(false);
          viewOrderlogDetails(responseData);
          setAlertPopup(false);
        })
        .catch((err) => {
          console.log(err);
          setAlertPopup(false);
          setIsLoading(false);
        });
      const myInterval = setInterval(() => {
        if (numberOfAjaxCAllPending === 0) {
          numberOfAjaxCAllPending++;
          clearInterval(myInterval);
          setAlertPopup(true);
          setIsLoading(false);
        }
      }, timeInterval);
    },
    [viewOrderlogDetails],
  );

  const viewStripepaymentlogDetails = (stripelog) => {
    const requestval = stripelog.requestValue.replace(/\//g, "");
    const responseval = stripelog.responseValue.replace(/\//g, "");
    const price =
      Number(JSON.parse(stripelog.requestValue.replace(/\//g, "")).amount) /
      100;
    let popupResult = (
      <Popup
        extClass="order-pop pop-container-sm"
        headMoreTxt={
          <>
            <div className="order-top">
              <div className="head">
                <h4>{t("stripe_payment_log_details_txt")}</h4>
              </div>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
            <div className="order-top">
              <div className="bottom vendor-details stripelogdetails">
                <p>
                  <span className="labeltxt">{t("account_code_txt")}</span>:{" "}
                  {stripelog.accountCode}
                </p>
                <p>
                  <span className="labeltxt">{t("order_number_txt")}</span>:{" "}
                  {stripelog.orderID}
                </p>
                <p>
                  <span className="labeltxt">{t("stripe_token_txt")}</span>:{" "}
                  {stripelog.referenceToken}
                </p>
                <p>
                  <span className="labeltxt">{t("request_value_txt")}</span>:{" "}
                  {requestval}
                </p>
                <p>
                  <span className="labeltxt">{t("response_value_txt")}</span>:{" "}
                  {responseval}
                </p>
                <p>
                  <span className="labeltxt">{t("total_amount_txt")}</span>:{" "}
                  {priceFormat(price)}
                </p>
                <p>
                  <span className="labeltxt">{t("created_date_txt")}</span>:{" "}
                  {moment(stripelog.createdAt).format("DD-MM-YYYY")}
                </p>
              </div>
            </div>
          </>
        }
        closebtn={
          <>
            <span onClick={() => setPopupView("")} className="close"></span>
          </>
        }
      />
    );
    setPopupView(popupResult);
  };

  const handleReset = () => {
    setSearchTextVal("");
    setStripeloglist(templist);
  };

  const filterData = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue.length > 0) {
      const result = templist.filter((item) => {
        return (
          item.accountCode.toString().toLowerCase().includes(lowercasedValue) ||
          (item.orderID &&
            item.orderID.toString().toLowerCase().includes(lowercasedValue)) ||
          (item.referenceToken &&
            item.referenceToken
              .toString()
              .toLowerCase()
              .includes(lowercasedValue))
        );
      });
      setStripeloglist(result);
    } else {
      setStripeloglist(templist);
    }
  };

  const handleChange = (value) => {
    setSearchTextVal(value);
    filterData(value);
  };

  const columns = [
    {
      name: t("account_code_txt"),
      selector: (row) => row.accountCode,
      sortable: true,
    },
    {
      name: t("order_number_txt"),
      selector: (row) => (
        <div style={{ display: "flex" }}>
          <a
            data-title={t("view_order_details_txt")}
            onClick={() => getOrderDetails(row)}
          >
            {row.orderID}
          </a>
        </div>
      ),
      sortable: true,
    },
    {
      name: t("stripe_token_txt"),
      selector: (row) => row.referenceToken,
      sortable: true,
    },
    {
      name: t("created_date_txt"),
      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY HH:mm:ss"),
      sortable: true,
    },
    {
      name: t("total_amount_txt"),
      selector: (row) =>
        priceFormat(
          Number(JSON.parse(row.requestValue.replace(/\//g, "")).amount) / 100,
        ),
      sortable: true,
      sortFunction: (a, b) => {
        const amountA =
          Number(JSON.parse(a.requestValue.replace(/\//g, "")).amount) / 100;
        const amountB =
          Number(JSON.parse(b.requestValue.replace(/\//g, "")).amount) / 100;
        return amountA - amountB;
      },
    },
    {
      name: t("actions_txt"),
      selector: (row) => (
        <div style={{ display: "flex" }}>
          <a
            className="button title-tooltip title-up"
            data-title={t("view_details_txt")}
            style={{ color: "white" }}
            onClick={() => viewStripepaymentlogDetails(row)}
          >
            <i className="fa fa-eye" aria-hidden="true"></i>
          </a>
        </div>
      ),
      sortable: false,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <>
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title">{t("stripe_payment_log_list")}</h1>
              <div className="right-table-outer-wrap">
                <div className="table-filter search-orders">
                  <div className="table-search-reset">
                    <div className="table-search">
                      <input
                        type="text"
                        value={searchTextVal}
                        onChange={(e) => handleChange(e.target.value)}
                        className="form-control"
                        placeholder={t("search_stripe_token_txt")}
                      />
                    </div>
                    <button
                      className="submitbtn button search-holi-btn"
                      onClick={() => filterData(searchTextVal)}
                    >
                      <i className="fa fa-search"></i>
                    </button>
                    <button
                      className="resetbtn"
                      type="reset"
                      onClick={handleReset}
                    >
                      {t("reset_txt")}
                    </button>
                  </div>
                </div>
                <div className="table_overflow stripelog-payment-table">
                  <DataTable
                    columns={columns}
                    noDataComponent={
                      <div className="no-records-found">
                        {t("no_matching_stripe_payment_log_txt")}
                      </div>
                    }
                    data={stripeloglist}
                    customStyles={customStyles}
                    pagination
                    paginationPerPage={25}
                    progressPending={loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={paginationComponentOptions}
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
        {popupView}
        {popupView1}
      </div>
    </>
  );
};

export default Stripepaymentlog;
